export default __webpack_public_path__ + "static/media/benchmark-preview.c277d904.png";